module.exports = __webpack_public_path__ + "img/bg1.3b9a6deb.png";